module.exports = __webpack_public_path__ + "images/supermarket-basket.png";